// import React, { useState } from 'react'
// import { Button, Checkbox, NewTable, PageHeader, PageTitle, Tag } from '../../../components'
// import { useNavigate } from 'react-router-dom';
// import { mapTableRows } from '../../../utils';
// import { Accountpayablesettingrows } from '../../../assets/data/candidatesData';

// const AccountsPayableSettings = () => {
//     const navigate = useNavigate();
//     const handleBack = () => {
//         navigate('/accounts-payable');
//     };

//     const tablerowData = Accountpayablesettingrows;
//     const AllbillsColumns = [

//         { key: " EmployeeName", label: " Employee Name" },
//         { key: "ApprovalDelegation", label: "Approval Delegation" },
//     ];

//     const mappedRows = mapTableRows(tablerowData, AllbillsColumns);
//     return (
//         <div>
//             <PageHeader
//                 Section={
//                     <div className="flex gap-3">
//                         <PageTitle title={"Accounts Payable Settings"} tag="h5" size={"sm"} />
//                     </div>
//                 }
//                 RightSection={
//                     <div className="flex gap-3">
//                         <Button
//                             size="sm"
//                             title={"Back"}
//                             icon={"arrow_left_alt"}
//                             onClick={handleBack}
//                         />
//                     </div>
//                 }
//             />
//             <div>
//                 <NewTable
//                 showCheckbox
//                     columns={AllbillsColumns}
//                     rows={mappedRows}
//                     toolbarRight={[
//                         { filterButton: false },
//                         { DropdownMenu: false },
//                     ]}
//                     customSection={
//                         <div className="ml-5 flex mr-4 gap-2">
//                             <Button
//                                 title="Change Approver"
//                                 size="sm"
//                                 color="black"
//                                 icon="add"
//                                 onClick={""}
//                             />
//                             <Button
//                                 title="Remove Approver"
//                                 size="sm"
//                                 color="black"
//                                 icon="add"
//                                 onClick={""}
//                             />
//                         </div>
//                     }
//                 />
//             </div>
//         </div>
//     )
// }

// export default AccountsPayableSettings

import React, { useEffect, useRef, useState } from "react";
// import { mapTableRows } from "../../../../utils/mapTableRows";
import { mapTableRows } from "../../../utils";
import {
  Alert,
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  NewTable,
  PageHeader,
  PageTitle,
  showToast,
  TableAdv,
} from "../../../components";
import CustomSection from "../../../components/Common/CustomSection";
// import { approvalDelegationData } from "../../../../assets/data/candidatesData";
import {
  bulkUpdateEmployeeStart,
  clearEmployeeData,
  getEmployeesStart,
  updateEmployeeStart,
} from "../../../redux/slices/employee/employeeSlice";
// import {
//   bulkUpdateEmployeeStart,
//   clearEmployeeData,
//   getEmployeesStart,
//   updateEmployeeStart,
// } from "../../../../redux/slices/employee/employeeSlice";
import { useDispatch, useSelector } from "react-redux";
// import { usePagination } from "../../../../hooks";
import { usePagination } from "../../../hooks";
import { getEmployeeId } from "../../../utils";
import useDropdownData from "../../../hooks/useDropdownData";
import { useNavigate } from "react-router-dom";
// import { getEmployeeName } from "../../../../utils/getDisplays";

const AccountsPayableSettings = () => {
  const containerRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, employees, totalCount } = useSelector(
    (state) => state.employee,
  );

  const [user, setUser] = useState("");
  const [employee, setEmployee] = useState("");

  const [changeApproverModal, setChangeApproverModal] = useState(false);
  const [removeApproverModal, setRemoveApproverModal] = useState(false);
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const [selectedEmployeeNames, setSelectedEmployeeNames] = useState([]);
  useEffect(() => {
    const fetchEmployees = async () => {
      //fetching with api
      // const promises = selectedEmployeeIds.map(async (id) => {
      //   const name = await getEmployeeName(id);
      //   return name;
      // });
      // const names = await Promise.all(promises);
      // setSelectedEmployeeNames(names);
      // fetchging with existing data
      const namesList =
        employees?.data
          ?.filter((employee) =>
            selectedEmployeeIds.includes(String(employee.uiid)),
          )
          .map((employee) => employee.firstName + " " + employee.lastName) ||
        [];
      console.log({
        selectedEmployeeIds,
        employees: employees?.data,
        namesList,
      });
      setSelectedEmployeeNames(namesList);
    };
    if (selectedEmployeeIds.length > 0) {
      fetchEmployees();
    }
  }, [selectedEmployeeIds]);

  //   const tableData = approvalDelegationData;
  // dropdown hook
  const {
    data: allSelectEmployeeListOptions,
    searchValue: allSelectEmployeeSearch,
    handleSearch: handleSelectEmployeeSearch,
    resetSearch: resetAllSelectEmployeeSearch,
    handleScroll: handleAllSelectEmployeeScroll,
  } = useDropdownData(
    "employeesSorted",
    10,
    {},
    {
      classification: 2,
    },
  );
  // pagination
  const { page, limit, setPage, handleLimitChange } = usePagination(10);

  const columns = [
    { key: "employeeName", label: "Employee Name", sortable: false },
    {
      key: "approvalDelegation",
      label: "Approval Delegation",
      sortable: false,
    },
  ];

  // const mappedRows = mapTableRows(tableData, columns);
  //   {
  //   id: 1,
  //   employeeName: "Abdul Waseem Syed (EMP-1001)",
  //   approvalDelegation: "Hemalatha Medisetti (EMP-075)",
  // },
  // {

  //mapping
  const mappedRows = mapTableRows(
    employees?.data?.map((emp) => ({
      id: emp?.uiid,
      employeeName:
        `${emp?.firstName} ${emp?.lastName} ` +
        getEmployeeId(emp.uiid, emp.employmentType),
      approvalDelegation:
        emp?.approvalFlow?.approvers?.length > 0
          ? emp?.approvalFlow?.approvers[0]
            ? `${emp?.approvalFlow?.approvers[0]?.firstName} ${
                emp?.approvalFlow?.approvers[0]?.lastName
              } ${getEmployeeId(
                emp?.approvalFlow?.approvers[0]?.uiid,
                emp?.approvalFlow?.approvers[0]?.employmentType,
              )} `
            : "-"
          : "-",
    })),
    columns,
  );
  // get employees table
  useEffect(() => {
    dispatch(
      getEmployeesStart({
        page: page,
        limit: limit,
        filters: {
          classification: {
            type: "NONE",
            value: 1,
          },
        },
        sort: { uiid: -1 },
        // sort: { uiid: 1 },
        ret: "uiid firstName lastName approvalFlow employmentType",
        ref: "Approver",
        incl: "uiid firstName lastName employmentType",
      }),
    );
    return () => {
      dispatch(clearEmployeeData());
    };
  }, [dispatch, page, limit]); // Empty array will cause it to run once when the component mounts

  //working handle chnage approver with loop
  // const handleChangeApprover = async () => {
  //   if (!selectedEmployeeIds.length) {
  //     showToast("Please select an employee", "error", 5000);
  //     return;
  //   }

  //   try {
  //     for (const id of selectedEmployeeIds) {
  //       try {
  //         await Promise.all([
  //           dispatch(
  //             updateEmployeeStart({
  //               coll: "Employee",
  //               uiid: id,
  //               payload: [
  //                 {
  //                   type: "SET",
  //                   value: { "approvalFlow.approvers.0": user },
  //                 },
  //               ],
  //             })
  //           ),
  //           dispatch(
  //             updateEmployeeStart({
  //               coll: "Employee",
  //               uiid: user,
  //               payload: [
  //                 {
  //                   type: "PUSH",
  //                   value: {
  //                     "approvalFlow.approverTo": id,
  //                   },
  //                 },
  //               ],
  //             })
  //           ),
  //         ]).then(() => {
  //           setUser("");
  //           setChangeApproverModal(false);

  //           setTimeout(() => {
  //             dispatch(
  //               getEmployeesStart({
  //                 page,
  //                 limit,
  //                 filters: {
  //                   classification: {
  //                     type: "NONE",
  //                     value: 1,
  //                   },
  //                 },
  //                 sort: { uiid: -1 },
  //                 ret: "uiid firstName lastName approvalFlow employmentType",
  //                 ref: "Approver",
  //                 incl: "uiid firstName lastName",
  //               })
  //             );
  //           }, 1200);
  //         });
  //       } catch (err) {
  //         showToast(`Failed to update employee ${id}`, "error", 5000);
  //         console.error(`Error updating employee ${id}:`, err);
  //         throw err; // Remove this line if you want to continue even after one fails
  //       }
  //     }
  //   } catch (finalError) {
  //     showToast("Bulk update failed. Please try again later.", "error", 5000);
  //     console.error("Bulk update error:", finalError);
  //   }
  // };

  const handleChangeApprover = async () => {
    if (!selectedEmployeeIds.length) {
      showToast("Please select an employee", "error", 5000);
      return;
    }
    console.log("selectedEmployeeIds", selectedEmployeeIds);
    let selectedEmployeesDataToFilter = employees?.data?.filter((emp) =>
      selectedEmployeeIds.includes(String(emp.uiid)),
    );
    const newIdWithoutUSerAsApprover = selectedEmployeesDataToFilter
      .map((employee) => {
        console.log({
          approvalFlow: employee.approvalFlow,
          user,
          employeeiD: employee.uiid,
        });
        if (
          employee.approvalFlow.approvers.some(
            (approver) => approver.uiid === user,
          )
        ) {
          return null;
        } else {
          return employee.uiid;
        }
      })
      .filter((el) => el);

    console.log(
      "employees with selectedEmployeeId filter data",
      selectedEmployeesDataToFilter,
    );
    // console.log(
    //   "employees with selectedEmployeeIds as uiid:",
    //   newIdWithoutUSerAsApprover
    // );
    console.log(
      "employees with selectedEmployeeIds as uiid without user:",
      newIdWithoutUSerAsApprover,
    );

    try {
      dispatch(
        bulkUpdateEmployeeStart({
          coll: "Employee",
          uiid: null,
          payload: [
            {
              type: "UPDATEMANY",
              value: {
                type: "SET",
                value: {
                  "approvalFlow.approvers.0": user,
                },
                fil: {
                  uiid: {
                    type: "IN",
                    value: selectedEmployeeIds?.map((id) => Number(id)) || [],
                  },
                },
              },
            },
            {
              type: "UPDATEONE",
              value: {
                type: "PUSH",
                value: {
                  "approvalFlow.approverTo": newIdWithoutUSerAsApprover,
                },
                fil: {
                  uiid: { type: "NONE", value: user },
                },
              },
            },
          ],
        }),
      );

      setUser("");
      setChangeApproverModal(false);

      setTimeout(() => {
        dispatch(
          getEmployeesStart({
            page,
            limit,
            filters: {
              classification: {
                type: "NONE",
                value: 1,
              },
            },
            sort: { uiid: -1 },
            ret: "uiid firstName lastName approvalFlow employmentType",
            ref: "Approver",
            incl: "uiid firstName lastName",
          }),
        );
      }, 1200);
    } catch (err) {
      showToast("Bulk update failed. Please try again later.", "error", 5000);
      console.error("Bulk update error:", err);
    }
  };

  //working
  const handleRemoveApprover = async () => {
    if (!selectedEmployeeIds.length) {
      showToast("Please select an employee", "error", 5000);
      return;
    }

    try {
      const updatePromises = selectedEmployeeIds.map((id) => {
        const employee = employees?.data?.find(
          (emp) => emp?.uiid === Number(id),
        );
        const approverId = employee?.approvalFlow?.approvers?.[0]?.uiid;
        console.log({ selectedEmployeeIds, employee, approverId });

        return Promise.all([
          dispatch(
            updateEmployeeStart({
              coll: "Employee",
              uiid: Number(id),
              payload: [
                {
                  type: "PULL",
                  value: {
                    "approvalFlow.approvers": approverId,
                  },
                },
              ],
            }),
          ),
          dispatch(
            updateEmployeeStart({
              coll: "Employee",
              uiid: approverId,
              payload: [
                {
                  type: "PULL",
                  value: {
                    "approvalFlow.approverTo": Number(id),
                  },
                },
              ],
            }),
          ),
        ]);
      });

      await Promise.all(updatePromises).then(() => {
        setRemoveApproverModal(false);

        setTimeout(() => {
          dispatch(
            getEmployeesStart({
              page,
              limit,
              filters: {
                classification: {
                  type: "NONE",
                  value: 1,
                },
              },
              sort: { uiid: -1 },
              ret: "uiid firstName lastName approvalFlow employmentType",
              ref: "Approver",
              incl: "uiid firstName lastName",
            }),
          );
        }, 1200);
      });
    } catch (error) {
      console.error("error in handleRemoveApprover", error);
      showToast(
        "Failed to remove approver(s). Please try again.",
        "error",
        5000,
      );
    }
  };

  //with bulk api not updated
  // const handleRemoveApprover = async () => {
  //   if (!selectedEmployeeIds.length) {
  //     showToast("Please select an employee", "error", 5000);
  //     return;
  //   }

  //   try {
  //     const approverMappings = selectedEmployeeIds.map((id) => {
  //       const employee = employees?.data?.find((emp) => emp?.uiid === id);
  //       return {
  //         id,
  //         approverId: employee?.approvalFlow?.approvers?.[0]?.uiid,
  //       };
  //     });

  //     const employeeIds = approverMappings.map((item) => item.id);
  //     const approverIds = approverMappings
  //       .map((item) => item.approverId)
  //       .filter(Boolean);

  //     dispatch(
  //       bulkUpdateEmployeeStart({
  //         coll: "Employee",
  //         uiid: null,
  //         payload: [
  //           {
  //             type: "UPDATEMANY",
  //             value: {
  //               type: "PULL",
  //               value: {
  //                 "approvalFlow.approvers": approverIds,
  //               },
  //               fil: {
  //                 uiid: { type: "IN", value: employeeIds },
  //               },
  //             },
  //           },
  //           {
  //             type: "UPDATEMANY",
  //             value: {
  //               type: "PULL",
  //               value: {
  //                 "approvalFlow.approverTo": employeeIds,
  //               },
  //               fil: {
  //                 uiid: { type: "IN", value: approverIds },
  //               },
  //             },
  //           },
  //         ],
  //       })
  //     );

  //     setRemoveApproverModal(false);

  //     setTimeout(() => {
  //       dispatch(
  //         getEmployeesStart({
  //           page,
  //           limit,
  //           filters: {
  //             classification: {
  //               type: "NONE",
  //               value: 1,
  //             },
  //           },
  //           sort: { uiid: -1 },
  //           ret: "uiid firstName lastName approvalFlow employmentType",
  //           ref: "Delegator",
  //           incl: "uiid firstName lastName",
  //         })
  //       );
  //     }, 1200);
  //   } catch (error) {
  //     showToast(
  //       "Failed to remove approver(s). Please try again.",
  //       "error",
  //       5000
  //     );
  //   }
  // };

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <PageHeader
        Section={
          <div className="flex gap-3">
            <PageTitle
              title={"Accounts Payable Settings"}
              tag="h5"
              size={"sm"}
            />
          </div>
        }
        RightSection={
          <div className="flex gap-3">
            <Button
              size="sm"
              title={"Back"}
              icon={"arrow_left_alt"}
              onClick={handleBack}
            />
          </div>
        }
      />
      {/* <div className="w-full flex justify-center">
        <div className="w-full max-w-7xl"> */}
          <TableAdv
            tableId={"accountspayable_accountspayablesettings"}
            showCheckbox
            rows={mappedRows}
            columns={columns}
            serverPagination={true}
            totalCount={totalCount?.data}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            defaultSelectedRows={selectedEmployeeIds}
            onSelectionChange={(change) => {
              setSelectedEmployeeIds(change);
            }}
            // toolbarRight={[
            //   { filterButton: false },
            //   { DropdownMenu: false },
            //   // {hideToolbar:true}
            // ]}
            toolbarRight={{
              search: true,
              add: [
                {
                  component: selectedEmployeeIds.length > 0 && (
                    <CustomSection>
                      <Button
                        variant="contained"
                        size="sm"
                        title={"Change Approver"}
                        onClick={() => setChangeApproverModal(true)}
                        color="black"
                        icon="person_add"
                      />
                      <Button
                        variant="contained"
                        size="sm"
                        title={"Remove Approver"}
                        onClick={() => setRemoveApproverModal(true)}
                        color="black"
                        icon="person_remove"
                      />
                    </CustomSection>
                  ),
                },
              ],
            }}
          />
        {/* </div>
      </div> */}
      <Modal
        isOpen={changeApproverModal}
        onClose={() => setChangeApproverModal(false)}
        title="Change Approver"
        width="max-w-4xl"
      >
        <div>
          <div className="flex flex-col max-w-[50%] gap-3">
            <div className="">
              <FormFieldSet
                type={"select"}
                title={"User"}
                placeholder="Select Approver"
                value={user}
                onChange={setUser}
                options={allSelectEmployeeListOptions}
                keyname="employeesSorted"
                showSearch
                searchValue={allSelectEmployeeSearch}
                onClose={resetAllSelectEmployeeSearch}
                refData={containerRef}
                onSearch={handleSelectEmployeeSearch}
                handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
              />
            </div>
            <div>
              <p>Can submit timesheets on behalf of:</p>
            </div>
            <div className="">
              <FormFieldSet
                type={"textArea"}
                // placeholder=". Aaron carter (CON-2112)"
                placeholder="Selected Employee(s)"
                title="Employee(s)"
                // value={employee}
                // onChange={setEmployee}
                value={selectedEmployeeNames.join(", ")}
                disabled={true}
              />
            </div>
          </div>
          <div className="flex gap-3 justify-end">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => {
                setUser("");
                setChangeApproverModal(false);
              }}
            />
            <Button
              title={"OK"}
              // onClick={() => setChangeApproverModal(false)}
              onClick={handleChangeApprover}
            />
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={removeApproverModal}
        onClose={() => setRemoveApproverModal(false)}
        title="Remove Approver"
        width="max-w-4xl"
      >
        <div>
          <div className="mb-20">
            <p>
              Are you sure you want to remove the assigned delegate from the
              selected employee(s) ?
            </p>
          </div>
          <div className="flex gap-3 justify-end">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => setRemoveApproverModal(false)}
            />
            <Button title={"OK"} onClick={handleRemoveApprover} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AccountsPayableSettings;
